var sliderContainers = document.querySelectorAll(
	'.pl_cursos_disponbles-slider-container'
);
var dropdownList = document.getElementById('dropdown-list');

// Almacenar la posiciA3n original de los sliders
var originalSliderPositions = [];

sliderContainers.forEach(function(sliderContainer) {
	var slider = sliderContainer.querySelector('.pl_cursos_disponbles-slider');
	if (!slider) {
		return;
	}
	var slides = slider.querySelectorAll('.pl_cursos_disponbles-slide');
	if (!slides.length) {
		return;
	}
	var slideWidth = slides[0].clientWidth + 16; // Ajuste de 16px para el margen derecho
	var progressBar = sliderContainer.querySelector(
		'.pl_cursos_disponbles-slider-progress .pl_cursos_disponbles-slider-progress-fill'
	);
	var prevButton = sliderContainer.querySelector(
		'.pl_cursos_disponbles-prev-btn'
	);
	var nextButton = sliderContainer.querySelector(
		'.pl_cursos_disponbles-next-btn'
	);
	var slideIndex = 0;
	var startX;
	var isDragging = false;

	function getMaxIndex() {
		var containerWidth = sliderContainer.clientWidth;
		var visibleCount = Math.max(1, Math.floor(containerWidth / slideWidth));

		return Math.max(0, slides.length - visibleCount);
	}

	// Almacenar la posiciA3n original del slider
	originalSliderPositions.push(slider.style.marginLeft);

	function slideTo(index) {
		var maxIndex = getMaxIndex();

		if (index < 0) {
			index = 0;
		}

		if (index > maxIndex) {
			index = maxIndex;
		}
		var marginLeft = -(index * slideWidth);
		slider.style.marginLeft = marginLeft + 'px';
		slideIndex = index;

		// Ocultar/Mostrar botones Prev/Next segA?n el A-ndice de la diapositiva
		if (prevButton) {
			prevButton.style.display = index === 0 ? 'none' : 'block';
		}
		if (nextButton) {
			nextButton.style.display = index === maxIndex ? 'none' : 'block';
		}

		// Actualizar el progreso de la barra
		var progress = maxIndex === 0 ? 100 : (index / maxIndex) * 100;
		if (progressBar) {
			progressBar.style.width = progress + '%';
		}

		// Cambiar el color de la barra de progreso
		if (progressBar) {
			if (index > 0) {
				progressBar.classList.add(
					'pl_cursos_disponbles-slider-progress-active'
				);
			} else {
				progressBar.classList.remove(
					'pl_cursos_disponbles-slider-progress-active'
				);
			}
		}
	}

	function slidePrev() {
		var newIndex = slideIndex - 1;
		var minIndex = 0;

		if (newIndex < minIndex) {
			newIndex = minIndex;
		}

		slideTo(newIndex);
	}

	function slideNext() {
		var newIndex = slideIndex + 1;
		var maxIndex = getMaxIndex();

		if (newIndex > maxIndex) {
			newIndex = maxIndex;
		}

		slideTo(newIndex);
	}

	function handleTouchStart(event) {
		isDragging = true;
		startX = event.touches[0].clientX;
	}

	function handleTouchMove(event) {
		if (!isDragging) {
			return;
		}

		var currentX = event.touches[0].clientX;
		var diffX = currentX - startX;

		if (diffX > 0) {
			// Deslizamiento hacia la derecha
			slidePrev();
		} else if (diffX < 0) {
			// Deslizamiento hacia la izquierda
			slideNext();
		}

		isDragging = false; // Restablecer el estado de arrastre
	}

	// Restablecer la posiciA3n original del slider
	function resetSliderPosition() {
		slideTo(Math.min(slideIndex, getMaxIndex()));
	}

	// Restablecer la posiciA3n al cargar la pA?gina
	resetSliderPosition();

	// Restablecer la posiciA3n al cambiar la categorA-a seleccionada
	if (dropdownList) {
		dropdownList.addEventListener('change', function() {
			resetSliderPosition();
			slideIndex = 0; // Reiniciar el A-ndice de la diapositiva al cambiar la categorA-a
			slideTo(slideIndex);
		});
	}

	// Manejadores de eventos
	if (prevButton) {
		prevButton.addEventListener('click', slidePrev);
	}
	if (nextButton) {
		nextButton.addEventListener('click', slideNext);
	}
	sliderContainer.addEventListener('touchstart', handleTouchStart);
	sliderContainer.addEventListener('touchmove', handleTouchMove);
});

// Filtrar diapositivas segA?n la opciA3n seleccionada en el dropdown
if (dropdownList) {
	dropdownList.addEventListener('change', function() {
		var selectedCategory = dropdownList.value;

		if (selectedCategory === 'todos') {
			// Mostrar todas las diapositivas si se selecciona 'Todos'
			sliderContainers.forEach(function(sliderContainer) {
				sliderContainer.style.display = 'block';
			});
		} else {
			// Ocultar diapositivas que no coincidan con la categorA-a seleccionada
			sliderContainers.forEach(function(sliderContainer) {
				var categoria = sliderContainer.getAttribute('data-categoria');

				if (categoria === selectedCategory) {
					sliderContainer.style.display = 'block';
				} else {
					sliderContainer.style.display = 'none';
				}
			});
		}

		// Verificar si el botA3n "Next" debe mostrarse despuAcs de filtrar
		sliderContainers.forEach(function(sliderContainer) {
			var slider = sliderContainer.querySelector(
				'.pl_cursos_disponbles-slider'
			);
			if (!slider) {
				return;
			}
			var slides = slider.querySelectorAll('.pl_cursos_disponbles-slide');
			if (!slides.length) {
				return;
			}
			var slideWidth = slides[0].clientWidth + 16;
			var containerWidth = sliderContainer.clientWidth;
			var visibleCount = Math.max(
				1,
				Math.floor(containerWidth / slideWidth)
			);
			var maxIndex = Math.max(0, slides.length - visibleCount);
			var nextButton = sliderContainer.querySelector(
				'.pl_cursos_disponbles-next-btn'
			);

			if (!nextButton) {
				return;
			}

			if (slides.length > 0 && maxIndex > 0) {
				nextButton.style.display = 'block';
			} else {
				nextButton.style.display = 'none';
			}
		});
	});
}
